import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';

import * as Accounts from 'accounts/components';

class AccountsRowContainer extends Component {
  render = () => (
    <Accounts.Row
      handleToggle={this.props.handleToggle}
      account={this.props.account}
      company={this.props.company}
      subcompany={this.props.subcompany}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  permissions: getPermissions(state),
  company: getCompany(state),
  subcompany: getSubcompany(state),
});

export default connect(mapStateToProps, null)(AccountsRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/containers/AccountRowContainer.js